import { LoadingOutlined } from '@ant-design/icons';
import { useQuery } from '@apollo/client';
import { Button, Col, Row, Spin, Tag } from 'antd';
import Text from 'antd/lib/typography/Text';
import React from 'react';
import { tableColumnTextFilterConfig } from 'src/components/tableUtils';
import { downloadFile } from 'src/lib/axios';
import { QueryGetCampaignEmails } from 'src/lib/gql/queries';
import { VisitorsTable } from 'src/lib/interface';
import InfoTable from '../components/info-table';

const Visitors = () => {
	const { data: qryData, loading } = useQuery(QueryGetCampaignEmails, {
		fetchPolicy: 'cache-and-network',
	});

	const p_Visitors: VisitorsTable[] = [];

	qryData?.getCampaignEmails?.forEach((visitor: any, i: number) => {
		return p_Visitors.push({
			id: visitor?.id || '',
			key: (i + 1).toString(),
			email: visitor?.email || '',
			unSubscribed: visitor?.unSubscribed || false,
		});
	});

	const columns = [
		{
			title: 'ID',
			dataIndex: 'key',
			width: 80,
			align: 'center',
			render: (key: number) => {
				return key;
			},
		},
		{
			title: 'Email',
			dataIndex: 'email',
			key: 'email',
			width: 300,
			...tableColumnTextFilterConfig<VisitorsTable>(),
			onFilter: (value, record) => {
				return record.email
					.toString()
					.toLowerCase()
					.includes(value.toString().toLowerCase());
			},
		},
		{
			title: 'Subscribed',
			dataIndex: 'unSubscribed',
			key: 'unSubscribed',
			width: 120,
			align: 'center',
			filters: [
				{
					text: 'Subscribed',
					value: false,
				},
				{
					text: 'Unsubscribed',
					value: true,
				},
			],
			filterMultiple: false,
			onFilter: (value, record) => {
				return record.unSubscribed === value;
			},
			render: (unSubscribed: boolean) => {
				return (
					<Tag
						color={unSubscribed ? 'red' : 'green'}
						style={{
							margin: '2px',
						}}
					>
						{unSubscribed ? 'UNSUBSCRIBED' : 'SUBSCRIBED'}
					</Tag>
				);
			},
		},
	];

	return (
		<Row>
			<Col
				span={24}
				style={{
					display: 'flex',
					marginBottom: '2rem',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}
			>
				<Text
					className="sub-header"
					style={{
						fontSize: 'clamp(16px, 1vw, 1.1vw)',
					}}
				>
					Visitors
				</Text>
				<Button
					onClick={() => {
						downloadFile({
							endpoint: '/csv-export/visitors',
						}).then(undefined);
					}}
				>
					Export Visitors Data
				</Button>
			</Col>

			<Col span={24}>
				<Spin indicator={<LoadingOutlined />} spinning={loading}>
					<InfoTable
						data={p_Visitors}
						columnData={columns}
						onChange={undefined}
						pagination={{
							total: p_Visitors.length,
						}}
						other={{
							scroll: {
								x: 300,
							},
						}}
					/>
				</Spin>
			</Col>
		</Row>
	);
};

export default Visitors;
